import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pickRequest',
  standalone: true
})
export class PickRequestPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value === 'SMART_SHELF') {
      return 'SHELF';
    }
    if (value === 'SMART_ROOM') {
      return 'SMART ROOM';
    }
    if (value === 'RETRIEVE FROM KIOSK') {
      return 'IN-LOCKER';
    }
    return value;
  }

}
